<template>
  <div :class="withSeparator ? 'tw:border-b tw:border-zinc-200' : ''">
    <div class="tw:flex tw:items-start tw:justify-between tw:gap-4 tw:py-5">
      <div class="tw:min-w-0 tw:flex-1">
        <p
          v-if="label"
          class="tw:mb-2 tw:text-xs tw:font-semibold tw:uppercase tw:tracking-wide tw:text-zinc-400"
        >
          {{ label }}
        </p>
        <slot></slot>
      </div>
      <div v-if="$slots.action" class="tw:flex-none">
        <slot name="action"></slot>
      </div>
    </div>
  </div>
</template>

<script setup>
/**
 * One row of the booking summary: what the step holds on the left, its edit control on the right.
 *
 * The label names the step so the order reads at a glance. Aligned to the top rather than centred,
 * so the edit control stays put whatever the height of the content beside it.
 */
defineProps({
  label: {
    type: String,
    default: null
  },
  withSeparator: {
    type: Boolean,
    default: true
  }
});
</script>
